import React from 'react';
import ReactDOM from 'react-dom';
import './scss/main.scss';

import LargeLogo from './site/parts/LargeLogo/index';
import SmallLogo from './site/parts/SmallLogo/index';
import SearchIcon from './site/parts/Search/index';
import Header from './site/parts/header/Component/index';
import Section from './site/parts/Section/index';
import Ingress from './site/parts/ingress/Component/index';
import Cards from './site/parts/cards/Component/index';
import InfoBox from './site/parts/infobox/Component/index';
import EditorBox from './site/parts/editorbox/Component/index';
import SectionSlideshow from './site/parts/section-slideshow/Component/index';
import PropertyShow from './site/parts/property-show/Component/index';
import ArticleShow from './site/parts/article-show/Component/index';
import RentalShow from './site/parts/rental-show/Component/index';
import PropertyPrice from './site/parts/PropertyComponents/PropertyPrice/index';
import PropertySize from './site/parts/PropertyComponents/PropertySize/index';
import PropertyType from './site/parts/PropertyComponents/PropertyType/index';
import PropertyList from './site/parts/property-list/Component/index';
import RentalList from './site/parts/rental-list/Component/index';
import EmployeeList from './site/parts/employee-list/Component/index';
import Person from './site/parts/Person/index';
import Map from './site/parts/Map/index';
import Swipe from './site/parts/Swipe/index';
import MobileMenu from './site/parts/MobileMenu/index';
import DesktopMenu from './site/parts/DesktopMenu/index';
import Footer from './site/parts/footer/Component/index';
import Faq from './site/parts/faq/Component/index';
import TextIntro from './site/parts/text-intro/Component/index';
import Message from './site/parts/message/Component/index';
import CallToAction from './site/parts/call-to-action/Component/index';
import LinkBox from './site/parts/link-box/Component/index';
import Handbook from './site/parts/handbook/Component/index';
import Form from './site/parts/form/Component/index';
import Forms from './site/parts/Forms/index';
import Input from './site/parts/Forms/FormComponents/Input/index';
import BoligSoknad from './site/parts/Forms/forms/BoligSoknad/index';
import Soker from './site/parts/Forms/forms/BoligSoknad/Soker/index';
import Faktura from './site/parts/Forms/forms/Faktura/index';
import Search from './site/parts/Search/index';
import SearchResults from './site/parts/search-results/Component/index';
import TextBoxes from './site/parts/textboxes/Component/index';
import ImageText from './site/parts/image-text/Component/index';
import MapGeneric from './site/parts/map-generic/Component/index';
import HandbookShow from './site/parts/handbook-show/Component/index';
import PropertySlideshow from './site/parts/property-slideshow/Component/index';
import Videoplayer from './site/parts/videoplayer/Component/index';

window.React = React;
window.ReactDOM = ReactDOM;
window.components = {
    LargeLogo,
    SmallLogo,
    SearchIcon,
    Header,
    Section,
    Ingress,
    Cards,
    InfoBox,
    EditorBox,
    SectionSlideshow,
    PropertyShow,
    ArticleShow,
    RentalShow,
    PropertyPrice,
    PropertySize,
    PropertyType,
    PropertyList,
    RentalList,
    EmployeeList,
    Person,
    Map,
    Swipe,
    MobileMenu,
    DesktopMenu,
    Footer,
    Faq,
    TextIntro,
    Message,
    CallToAction,
    LinkBox,
    Handbook,
    Form,
    Forms,
    Input,
    BoligSoknad,
    Soker,
    Faktura,
    Search,
    SearchResults,
    TextBoxes,
    ImageText,
    MapGeneric,
    HandbookShow,
    PropertySlideshow,
    Videoplayer
};



// WEBPACK FOOTER //
// ./src/main/resources/index.jsx